import { useEffect } from "react";

const useFixedBody = (bodyIsFixed) => {
  useEffect(() => {
    if (bodyIsFixed) {
      return document.body.classList.add("fixed");
    }
    document.body.classList.remove("fixed");
  }, [bodyIsFixed]);
};

export default useFixedBody;
